import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

const AddCategoryModal = ({ handleClose, show, onAdd }) => {
    const [categoryName, setCategoryName] = useState('');
    const [categoryDesc, setCategoryDesc] = useState('');
    const [createdBy, setCreatedBy] = useState('');

    useEffect(() => {
        setCreatedBy(localStorage.getItem('badgeID'));
    }, []);

    const onSubmit = (e) => {
        e.preventDefault();

        if (!categoryName) {
            alert('Please enter a folder name');
        } else if (!categoryDesc) {
            alert('Please enter your folder description');
        } else {
            onAdd({
                categoryName,
                categoryDesc,
                createdBy,
            });

            setCategoryName('');
            setCategoryDesc('');
        }
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title style={{ marginBottom: '0px' }}>
                    Create New Folder
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={onSubmit}>
                    <Form.Group className='mb-3'>
                        <Form.Label>Folder Name</Form.Label>
                        <Form.Control
                            type='text'
                            placeholder='Insert your folder name here...'
                            style={{ width: '100%' }}
                            value={categoryName}
                            onChange={(e) => setCategoryName(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className='mb-3'>
                        <Form.Label>Folder Description</Form.Label>
                        <Form.Control
                            type='text'
                            placeholder='Insert your folder description here...'
                            style={{ width: '100%' }}
                            value={categoryDesc}
                            onChange={(e) => setCategoryDesc(e.target.value)}
                        />
                    </Form.Group>
                    <Button as='input' type='submit' value='Submit' />
                    <Button variant='outline-secondary' onClick={handleClose}>
                        Close
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default AddCategoryModal;
